import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

// True when running inside the Capacitor native app (Android/iOS), false on web.
export const isNative = () => {
  try {
    return Capacitor?.isNativePlatform?.() === true;
  } catch {
    return false;
  }
};

const ACCESS_KEY = "ud_access_token";
const REFRESH_KEY = "ud_refresh_token";

export async function setTokens(access, refresh) {
  if (access !== undefined) await Preferences.set({ key: ACCESS_KEY, value: access || "" });
  if (refresh !== undefined) await Preferences.set({ key: REFRESH_KEY, value: refresh || "" });
}

export async function getAccessToken() {
  const { value } = await Preferences.get({ key: ACCESS_KEY });
  return value || null;
}

export async function getRefreshToken() {
  const { value } = await Preferences.get({ key: REFRESH_KEY });
  return value || null;
}

export async function clearTokens() {
  await Preferences.remove({ key: ACCESS_KEY });
  await Preferences.remove({ key: REFRESH_KEY });
}
